import { render } from "./ribbons3.vue?vue&type=template&id=7a13a0dc"
import script from "./ribbons3.vue?vue&type=script&lang=js"
export * from "./ribbons3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__